export const getWatchlistPlayers = {
  persons: {
    items: [
      {
        id: '624cd7ca0632e700e0e1ce62',
        nativeGivenName: 'VVbMjChildFN',
        nativeFamilyName: 'zOmfyChildLN',
        nationalityCode: 'USA',
        sex: 'M',
        age: 9,
        birthDate: '2013-04-05',
        biographicalInformation: null,
        ratings: [],
        __typename: 'Person',
      },
      {
        id: '624cd77e0632e74360e1ce61',
        nativeGivenName: 'BachIChildFN',
        nativeFamilyName: 'LCHahChildLN',
        nationalityCode: 'USA',
        sex: 'M',
        age: 9,
        birthDate: '2013-04-05',
        biographicalInformation: null,
        ratings: [],
        __typename: 'Person',
      },
      {
        id: '624cd7140632e7240de1ce60',
        nativeGivenName: 'SqXDwChildFN',
        nativeFamilyName: 'dCSgpChildLN',
        nationalityCode: 'USA',
        sex: 'M',
        age: 9,
        birthDate: '2013-04-05',
        biographicalInformation: null,
        ratings: [],
        __typename: 'Person',
      },
      {
        id: '624cd7020632e756ebe1ce5f',
        nativeGivenName: 'CYoegChildFN',
        nativeFamilyName: 'JHjtBChildLN',
        nationalityCode: 'USA',
        sex: 'M',
        age: 9,
        birthDate: '2013-04-05',
        biographicalInformation: null,
        ratings: [],
        __typename: 'Person',
      },
      {
        id: '624cd6f70632e71424e1ce5e',
        nativeGivenName: 'VGoVfjuniorName',
        nativeFamilyName: 'DDZsjjuniorLastName',
        nationalityCode: 'USA',
        sex: 'F',
        age: 16,
        birthDate: '2006-03-04',
        biographicalInformation: null,
        ratings: [],
        __typename: 'Person',
      },
      {
        id: '624cd6b70632e75f0be1ce5d',
        nativeGivenName: 'kyGTcChildFN',
        nativeFamilyName: 'qNOswChildLN',
        nationalityCode: 'USA',
        sex: 'M',
        age: 16,
        birthDate: '2006-04-05',
        biographicalInformation: null,
        ratings: [],
        __typename: 'Person',
      },
    ],
    __typename: 'PersonList',
  },
}
